module.exports = __webpack_public_path__ + "static/img/anli8.8bd853a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/anli/anli8.jpg
// module id = G/t9
// module chunks = 1